import { render, staticRenderFns } from "./contentHerder.vue?vue&type=template&id=600cee06&scoped=true"
import script from "./contentHerder.vue?vue&type=script&lang=js"
export * from "./contentHerder.vue?vue&type=script&lang=js"
import style0 from "./contentHerder.vue?vue&type=style&index=0&id=600cee06&prod&lang=scss&scoped=true"
import style1 from "./contentHerder.vue?vue&type=style&index=1&id=600cee06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600cee06",
  null
  
)

export default component.exports